import { PackageType } from '@frontend/package/types';
import { ScreenType } from '@frontend/wizard/types';

import { useColliConfirmOpenSlotsSerial } from '../../hooks/use-colli-confirm-open-slots-serial';

const usePickUpConfirmOpenSlotsSerial = () =>
    useColliConfirmOpenSlotsSerial({
        screenType: ScreenType.PICK_UP_CONFIRM_OPEN_SLOTS_SERIAL,
        packageType: PackageType.PICK_UP
    });

export default usePickUpConfirmOpenSlotsSerial;
